	import wixLocation from 'wix-location';

	$w.onReady(function () {
	
		if($w("#anchorText").text  == "anchor1"){
			$w("#anchorText").text = "";
			$w("#anchor1").scrollTo();
		}
	});






// export function anchor1_viewportEnter(event, $w) {

// 	$w("#TitleBox").hide(); 
// }


export function titleShow_viewportLeave(event, $w) {
	$w("#TitleBox").hide("fade");
}

export function titleShow_viewportEnter(event, $w) {
	$w("#TitleBox").show(); 
}

export function Galleryanchor_viewportEnter(event, $w) {
	$w("#TitleBox").hide(); 
}